import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { SearchEngineComponent } from 'src/app/modules/search-engine/search-engine.component';
import { SwiperOptions } from 'swiper';
import {CmsService} from "../../services/cms.service";

@Component({
  selector: 'ui-slider',
  templateUrl: './ui-slider.component.html',
  styleUrls: ['./ui-slider.component.scss']
})
export class UiSliderComponent implements OnInit, AfterViewInit {
  @Input() component;
  @Input() parent;

  @ViewChild('engine', {
    read: ViewContainerRef
  }) viewContainerRef: ViewContainerRef;

  public config: SwiperOptions = {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    loop: true,
    slidesPerView: 1
  };
  public swiperIndex: number;

  public brand: any;

  constructor(
    private _factoryResolver: ComponentFactoryResolver,
    private _changeDetectorRef: ChangeDetectorRef,
    private _cmsService: CmsService,
  ) { }

  ngAfterViewInit(): void {
    const factory = this._factoryResolver.resolveComponentFactory(SearchEngineComponent);
    this.viewContainerRef.clear();
    this.viewContainerRef.createComponent(factory, null, this.viewContainerRef.injector);
    this._changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this._cmsService.brandConfig$.subscribe(brand => {
      if (brand) this.brand = brand;
    });
  }

}
